
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[Institution]",
      function () {
        return require("private-next-pages/[Institution].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[Institution]"])
      });
    }
  